import React from 'react';
import { connect } from 'react-redux';
import P from '@leverege/promise';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { Button } from '@leverege/ui-elements';
import { Blocker } from '@leverege/molten/views';
import { jsx as _jsx } from "react/jsx-runtime";
class DeviceLocationLink extends React.Component {
  constructor(props) {
    super(props);
    const {
      value,
      object
    } = props;
    this.initialLoad = P.deferred();
    this.show = false;
    if (value && value !== '-') {
      let ref = object.ref;
      const objType = object.type;
      const objGroup = `${objType}s`;
      if (ref.indexOf(value) === -1 && ref.endsWith(objGroup)) {
        ref = ref.replace(objGroup, `locations/${value}/${objGroup}`);
        const deviceObj = {
          id: object.id,
          ref,
          type: objType
        };
        this.deviceActions = DataSources.getActions(deviceObj);
        this.show = true;
      }
    }
  }
  componentDidMount() {
    const {
      value,
      device
    } = this.props;
    if (!device && value && this.deviceActions) {
      GlobalState.dispatch(this.deviceActions.get()).then(() => {
        this.initialLoad.resolve();
      });
    } else {
      this.initialLoad.resolve();
    }
  }
  onClick = () => {
    GlobalState.dispatch(this.deviceActions.parent().goTo(this.deviceActions.id));
  };
  renderChildren = () => {
    const {
      device
    } = this.props;
    if (device && this.show) {
      return /*#__PURE__*/_jsx(Button, {
        variant: "detailSecondary",
        onClick: this.onClick,
        children: "View In Location"
      });
    }
    return null;
  };
  render() {
    const matchContext = {
      client: 'DeviceLocationLink'
    };
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: matchContext,
      context: this.props,
      hooks: [{
        execute: () => this.initialLoad
      }],
      render: this.renderChildren,
      small: true,
      loadingProps: {
        inline: true
      }
    });
  }
}
export default connect((state, props) => {
  const {
    value
  } = props;
  const {
    models: {
      lookup
    }
  } = state;
  const device = lookup[value];
  return {
    device
  };
})(DeviceLocationLink);